"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@material-ui/core");

var _utils = _interopRequireDefault(require("../../../utils/utils"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RadioElement = function RadioElement(_ref) {
  var item = _ref.item;
  var defaultStyles = {};
  var style = !item.isActiveCustomStyles ? defaultStyles : _utils.default.stringToObject(item.customStyles);
  return /*#__PURE__*/React.createElement(_core.FormControl, {
    component: "fieldset",
    style: style
  }, /*#__PURE__*/React.createElement(_core.FormLabel, {
    component: "legend"
  }, item.label), /*#__PURE__*/React.createElement(_core.RadioGroup, {
    row: true,
    "aria-label": "position",
    name: item.name,
    value: item.value
  }, item.attributes.map(function (atr, i) {
    return /*#__PURE__*/React.createElement(_core.FormControlLabel, {
      key: i,
      disabled: true,
      value: atr.value,
      control: /*#__PURE__*/React.createElement(_core.Radio, {
        color: "primary"
      }),
      label: atr.labelInside
    });
  })));
};

var _default = RadioElement;
exports.default = _default;